module.exports = __webpack_public_path__ + "media/ספסל.81268ac7.mp3";